export const STORY_ROUTE_COMPONENTS = 'Lotus/Components/';
export const STORY_ROUTE_ELEMENT = 'Lotus/Elements/';
export const STORY_ROUTE_LAYOUT = 'Lotus/Layouts/';
export const STORY_ROUTE_FOUNDATION = 'Lotus/Foundataion/';

export const categoryOptions = [
  {id: 1, name: 'Category', alias: 'Category'},
  {id: 15, name: 'AI/ML', alias: 'AI/ML'},
  {id: 8, name: 'Data Analytics & BI', alias: 'Data Analytics & BI'},
  {id: 16, name: 'Data Engineering', alias: 'Data Engineering'},
  {id: 2, name: 'Backend Development', alias: 'Backend Development'},
  {id: 3, name: 'Frontend Development', alias: 'Frontend Development'},
  {id: 17, name: 'Full Stack', alias: 'Full Stack'},
  {id: 6, name: 'Mobile Applications', alias: 'Mobile Applications'},
  {id: 10, name: 'Emerging Technologies', alias: 'Emerging Technologies'},
  {id: 9, name: 'DevOps / SRE', alias: 'DevOps / SRE'},
  {id: 18, name: 'CyberSecurity', alias: 'CyberSecurity'},
  {id: 12, name: 'Quality Assurance', alias: 'Quality Assurance'},
  {
    id: 7,
    name: 'Platform Engineering / SAP/ Oracle',
    alias: 'Platform Engineering / SAP/ Oracle',
  },
  {id: 13, name: 'Product Management', alias: 'Product Management'},
  {
    id: 14,
    name: 'Business Analysis and Project Management',
    alias: 'Business Analysis and Project Management',
  },
  {id: 11, name: 'UI & Design', alias: 'UI & Design'},
  {id: 5, name: 'Semiconductor/VLSI/EDA', alias: 'Semiconductor/VLSI/EDA'},
  {id: 4, name: 'Others', alias: 'Others'},
];

export const methodOptions = [
  {id: 1, name: 'Method'},
  {id: 2, name: 'Online'},
  {id: 3, name: 'Blended'},
  {id: 4, name: 'Classroom'},
];

export const experienceOptions = [
  {id: 1, name: 'Any Exp. Level', minExp: 0, maxExp: 30},
  {id: 2, name: '0 - 1 yrs', minExp: 0, maxExp: 1},
  {id: 3, name: '2 - 3 yrs', minExp: 2, maxExp: 3},
  {id: 4, name: '4 - 6 yrs', minExp: 4, maxExp: 6},
  {id: 5, name: '7 - 10 yrs', minExp: 7, maxExp: 10},
  {id: 6, name: '11 - 15 yrs', minExp: 11, maxExp: 15},
  {id: 7, name: '16 - 20 yrs', minExp: 16, maxExp: 20},
  {id: 8, name: '21 - 25 yrs', minExp: 21, maxExp: 25},
  {id: 9, name: '26+ yrs', minExp: 26, maxExp: 30},
];

export const cities = [
  {
    id: 1,
    locationName: 'Bangalore',
    locationNameLower: 'bangalore',
  },
  {
    id: 2,
    locationName: 'Pune',
    locationNameLower: 'pune',
  },
  {
    id: 3,
    locationName: 'Chennai',
    locationNameLower: 'chennai',
  },
  {
    id: 4,
    locationName: 'Hyderabad',
    locationNameLower: 'hyderabad',
  },
  {
    id: 5,
    locationName: 'Mumbai',
    locationNameLower: 'mumbai',
  },
  {
    id: 6,
    locationName: 'Delhi NCR',
    locationNameLower: 'delhi-ncr',
  },
  {
    id: 7,
    locationName: 'Kolkata',
    locationNameLower: 'kolkata',
  },
  {
    id: 8,
    locationName: 'Coimbatore',
    locationNameLower: 'coimbatore',
  },
  {
    id: 9,
    locationName: 'Noida',
    locationNameLower: 'noida',
  },
  {
    id: 10,
    locationName: 'Gurgaon/Gurugram',
    locationNameLower: 'gurgaon-gurugram',
  },
  {
    id: 11,
    locationName: 'Indore',
    locationNameLower: 'indore',
  },
  {
    id: 12,
    locationName: 'Jaipur',
    locationNameLower: 'jaipur',
  },
  {
    id: 13,
    locationName: 'Chandigarh',
    locationNameLower: 'chandigarh',
  },
  {
    id: 14,
    locationName: 'Delhi',
    locationNameLower: 'delhi',
  },
  {
    id: 17,
    locationName: 'Greater Noida',
    locationNameLower: 'greater-noida',
  },
  {
    id: 18,
    locationName: 'Faridabad',
    locationNameLower: 'faridabad',
  },
  {
    id: 19,
    locationName: 'Ghaziabad',
    locationNameLower: 'ghaziabad',
  },
  {
    id: 20,
    locationName: 'Jammu & Kashmir',
    locationNameLower: 'jammu-&-kashmir',
  },
  {
    id: 21,
    locationName: 'Jammu',
    locationNameLower: 'jammu',
  },
  {
    id: 22,
    locationName: 'Srinagar',
    locationNameLower: 'srinagar',
  },
  {
    id: 23,
    locationName: 'Amritsar',
    locationNameLower: 'amritsar',
  },
  {
    id: 24,
    locationName: 'Jalandhar',
    locationNameLower: 'jalandhar',
  },
  {
    id: 25,
    locationName: 'Patiala',
    locationNameLower: 'patiala',
  },
  {
    id: 26,
    locationName: 'Sonipat',
    locationNameLower: 'sonipat',
  },
  {
    id: 27,
    locationName: 'Panipat',
    locationNameLower: 'panipat',
  },
  {
    id: 28,
    locationName: 'Ludhiana',
    locationNameLower: 'ludhiana',
  },
  {
    id: 29,
    locationName: 'Udaipur',
    locationNameLower: 'udaipur',
  },
  {
    id: 30,
    locationName: 'Jodhpur',
    locationNameLower: 'jodhpur',
  },
  {
    id: 31,
    locationName: 'Ahmedabad',
    locationNameLower: 'ahmedabad',
  },
  {
    id: 32,
    locationName: 'Surat',
    locationNameLower: 'surat',
  },
  {
    id: 33,
    locationName: 'Gandhinagar',
    locationNameLower: 'gandhinagar',
  },
  {
    id: 34,
    locationName: 'Vadodara/Baroda',
    locationNameLower: 'vadodara-baroda',
  },
  {
    id: 35,
    locationName: 'Haridwar',
    locationNameLower: 'haridwar',
  },
  {
    id: 36,
    locationName: 'Uttarakhand',
    locationNameLower: 'uttarakhand',
  },
  {
    id: 37,
    locationName: 'Lucknow',
    locationNameLower: 'lucknow',
  },
  {
    id: 38,
    locationName: 'Patna',
    locationNameLower: 'patna',
  },
  {
    id: 39,
    locationName: 'Jamshedpur',
    locationNameLower: 'jamshedpur',
  },
  {
    id: 40,
    locationName: 'Ranchi',
    locationNameLower: 'ranchi',
  },
  {
    id: 41,
    locationName: 'Chhattisgarh',
    locationNameLower: 'chhattisgarh',
  },
  {
    id: 42,
    locationName: 'Bhubaneshwar',
    locationNameLower: 'bhubaneshwar',
  },
  {
    id: 43,
    locationName: 'Nagpur',
    locationNameLower: 'nagpur',
  },
  {
    id: 44,
    locationName: 'Nasik',
    locationNameLower: 'nasik',
  },
  {
    id: 45,
    locationName: 'Navi Mumbai',
    locationNameLower: 'navi-mumbai',
  },
  {
    id: 46,
    locationName: 'Dehradun',
    locationNameLower: 'dehradun',
  },
  {
    id: 47,
    locationName: 'Thane',
    locationNameLower: 'thane',
  },
  {
    id: 48,
    locationName: 'Cochin/Kochi',
    locationNameLower: 'cochin-kochi',
  },
  {
    id: 49,
    locationName: 'Hosur',
    locationNameLower: 'hosur',
  },
  {
    id: 50,
    locationName: 'Trivandrum/Thiruvananthapuram',
    locationNameLower: 'trivandrum-thiruvananthapuram',
  },
  {
    id: 51,
    locationName: 'Raipur',
    locationNameLower: 'raipur',
  },
  {
    id: 52,
    locationName: 'Mysore',
    locationNameLower: 'mysore',
  },
  {
    id: 53,
    locationName: 'Hubli',
    locationNameLower: 'hubli',
  },
  {
    id: 54,
    locationName: 'Vijayawada',
    locationNameLower: 'vijayawada',
  },
  {
    id: 55,
    locationName: 'Vishakhapatnam/Vizag',
    locationNameLower: 'vishakhapatnam-vizag',
  },
  {
    id: 56,
    locationName: 'Guntur',
    locationNameLower: 'guntur',
  },
  {
    id: 57,
    locationName: 'Aurangabad',
    locationNameLower: 'aurangabad',
  },
  {
    id: 58,
    locationName: 'Rajkot',
    locationNameLower: 'rajkot',
  },
  {
    id: 59,
    locationName: 'Warangal',
    locationNameLower: 'warangal',
  },
  {
    id: 60,
    locationName: 'Varanasi/Banaras',
    locationNameLower: 'varanasi-banaras',
  },
  {
    id: 61,
    locationName: 'Madurai',
    locationNameLower: 'madurai',
  },
  {
    id: 63,
    locationName: 'Pondicherry',
    locationNameLower: 'pondicherry',
  },
  {
    id: 64,
    locationName: 'Cuttack',
    locationNameLower: 'cuttack',
  },
];

export const linkageCompanies = [
  [
    {
      name: 'Amazon',
    },
    {
      name: 'Byjus',
    },
    {
      name: 'Ola',
    },
    {
      name: 'Olx',
    },
    {
      name: 'Physics Wallah',
    },
    {
      name: 'Oyo',
    },
    {
      name: 'Spinny',
    },
    {
      name: 'Expedia',
    },
    {
      name: 'Redbus',
    },
    {
      name: 'Carwale',
    },
    {
      name: 'Groww',
    },
    {
      name: 'Myntra',
    },
  ],
  [
    {
      name: 'Mobikwik',
    },
    {
      name: 'Paytm',
    },
    {
      name: 'Zomato',
    },
    {
      name: 'Swiggy',
    },
    {
      name: 'Mx Player',
    },
    {
      name: 'Ola Electric',
    },
    {
      name: 'Vedantu',
    },
    {
      name: 'Intel',
    },
    {
      name: 'Nobroker',
    },
    {
      name: 'Airtel X Labs',
    },
    {
      name: 'Jabong',
    },
    {
      name: 'Bharatpe',
    },
  ],
];
